import env from 'enviro';
import { CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_GATE, CBX_FEATURE_STORE_DEFAULT_CONTENT_GATE, CBX_FEATURE_STORE_GATE, FEATURE_STORE_GATE, SEATS_FREE_TO_PRO_TOUCHLESS_FLOW_GATE, SEATS_FREE_TO_STARTER_TOUCHLESS_FLOW_GATE } from '../constants/Gates';
import { CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_FLAG, CBX_FEATURE_STORE_DEFAULT_CONTENT_FLAG, CBX_FEATURE_STORE_FLAG, SEATS_VERSIONS_FEATURE_FLAG } from '../constants/PublicFeatureFlags';
import { SEATS_ACCESS } from '../constants/Scopes';
import { getIsQAProxy } from './proxyUtils';
import safeLocalStorage from './safeLocalStorage';
export const getIsUngated = (state, {
  gateKey
}) => {
  const {
    gates
  } = state;
  const isQA = env.isQa() || getIsQAProxy();
  const override = safeLocalStorage.getItem(`${gateKey}_OVERRIDE`);

  if (override === 'true' && isQA) {
    return true;
  }

  return !!(gates && gates.indexOf(gateKey) !== -1);
};
export const getIsUngatedForFeatureStore = state => getIsUngated(state, {
  gateKey: FEATURE_STORE_GATE
});
export const getIsUngatedForSeats = state => {
  return getIsUngated(state, {
    gateKey: SEATS_VERSIONS_FEATURE_FLAG
  }) || getIsUngated(state, {
    gateKey: SEATS_ACCESS
  });
};
export const getIsUngatedForCBXFeatureStore = state => {
  return getIsUngated(state, {
    gateKey: CBX_FEATURE_STORE_GATE
  }) || getIsUngated(state, {
    gateKey: CBX_FEATURE_STORE_FLAG
  });
};
export const getIsUngatedForSeatsFreeToProTouchlessFlow = state => {
  return getIsUngated(state, {
    gateKey: SEATS_FREE_TO_PRO_TOUCHLESS_FLOW_GATE
  });
};
export const getIsUngatedForSeatsFreeToStarterTouchlessFlow = state => {
  return getIsUngated(state, {
    gateKey: SEATS_FREE_TO_STARTER_TOUCHLESS_FLOW_GATE
  });
};
export const getIsUngatedForCBXFeatureStoreBusinessObjectives = state => {
  return getIsUngated(state, {
    gateKey: CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_GATE
  }) || getIsUngated(state, {
    gateKey: CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_FLAG
  });
};
export const getIsUngatedForCBXFeatureStoreDefaultContent = state => {
  return getIsUngated(state, {
    gateKey: CBX_FEATURE_STORE_DEFAULT_CONTENT_GATE
  }) || getIsUngated(state, {
    gateKey: CBX_FEATURE_STORE_DEFAULT_CONTENT_FLAG
  });
};